import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeOCClaimInitialValues } from './normalize';

export const fetchOCClaimInitialValues = createProvider(api.fetchOCClaimInitialValues)
  .andThen((res) => normalizeOCClaimInitialValues(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
